<script setup lang="ts">
</script>

<template>
  <div class="surgeon-container">
    <RouterView />
  </div>
</template>

<style scoped lang="scss">
.surgeon-container {
  height: 100%;
}
</style>
